import { memo } from 'react';
import {
  IQuickFactContent,
  QuickFactTheme,
} from '@bridebook/toolbox/src/seo-facets/search-widgets';
import { cn } from '@bridebook/aura';
import { icons, useQuickFactsTitles } from './visuals';
import {
  SwirlGreenSpriteIcon,
  SwirlOrangeSpriteIcon,
  SwirlPurpleSpriteIcon,
  SwirlRedSpriteIcon,
} from '../search-svg-sprite';

interface IProps {
  item: IQuickFactContent;
  index: number;
}

const swirlIcons = {
  [QuickFactTheme.Purple]: <SwirlPurpleSpriteIcon width={195} height={158} />,
  [QuickFactTheme.Green]: <SwirlGreenSpriteIcon width={279} height={110} />,
  [QuickFactTheme.Orange]: <SwirlOrangeSpriteIcon width={178} height={143} />,
  [QuickFactTheme.Red]: <SwirlRedSpriteIcon width={133} height={178} />,
};

const QuickFactsItem = ({ item: { subType, content, description, theme }, index }: IProps) => {
  const titles = useQuickFactsTitles();

  return (
    <div className="bsqf-card" data-theme={theme}>
      <div className="bsqf-swirl" data-theme={theme}>
        {swirlIcons[theme]}
      </div>
      <div className="bsqf-content">
        {subType && titles[subType] && <h5 className="bsqf-card-title">{titles[subType]}</h5>}
        {content && (
          <span className={cn('bsqf-value', index > 5 ? 'bsqf-value-sm' : 'bsqf-value-lg')}>
            {content}
          </span>
        )}
        {description && <span className="bsqf-desc">{description}</span>}
      </div>
      <div className="bsqf-icon">{icons[index]}</div>
    </div>
  );
};

export default memo(QuickFactsItem);
